import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { mainRoutes } from '../utils/routelist';
import { exit_session } from './apiHandle';
import { PublicRoutes } from './PublicRoutes/PublicRoutes';
import { PrivateRoutes } from './PrivateRoutes/PrivateRoutes';
import { asyncStatus, save_tokens_constant } from '../utils/asyncStatus';
import { setAuthState, setIdleStatus } from '../store/slice/user_auth_slice';
import { check_auth } from '../services/authentication';
import { Progress } from 'antd';
import { ProgressBar } from 'primereact/progressbar';

const RouterApp = () => {
    const { check_auth_status, login_status } = useSelector((state) => state.userAuth);



    const dispatch = useDispatch();


    useEffect(() => {
        if (login_status === asyncStatus.SUCCEEDED) {
            dispatch(check_auth());
            dispatch(setIdleStatus())
        }
    }, [login_status])

    useEffect(() => {
        if (check_auth_status === asyncStatus.IDLE) {
            const authTokens = localStorage.getItem(save_tokens_constant.AUTH) || null;
            if (!authTokens) {
                dispatch(setAuthState(false));

            } else {
                dispatch(check_auth());

            }
        }
    }, [check_auth_status, dispatch]);

    if (check_auth_status === asyncStatus.IDLE || check_auth_status === asyncStatus.LOADING) {
        return (
            <div>
                <ProgressBar mode="indeterminate" className='bg-blue-900' style={{ height: '6px' }} />

            </div>
        );
    }

    if (check_auth_status === asyncStatus.ERROR) {
        return (
          <div className="h-[100vh] flex items-center justify-center bg-gray-50 px-4 py-12 rounded-lg shadow-sm border border-gray-200">
            <div className="max-w-md w-full space-y-6 text-center">
              <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                </svg>
              </div>
              
              <h2 className="text-2xl font-bold text-gray-900">Authentication Failed</h2>
              
              <p className="text-gray-600 mt-2">
                We couldn't verify your credentials. This could be due to an expired session or network issues.
              </p>
              
              <div className="pt-4">
                <button
                  onClick={exit_session}
                  className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-800 hover:bg-blue-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                  </svg>
                  Return to Home
                </button>
              </div>
              
              <div className="text-xs text-gray-500 mt-4">
                Error ID: AUTH-{Math.floor(Math.random() * 9000) + 1000}
              </div>
            </div>
          </div>
        );
      }
    return (
        <Router>
            <Routes >
                <Route element={<PublicRoutes />}>
                    {mainRoutes.map((route, i) => {
                        const { path, element, authRequired } = route;
                        return !authRequired && <Route key={i} path={path} element={element} />;
                    })}
                </Route>
                <Route element={<PrivateRoutes />}>
                    {mainRoutes.map((route, i) => {
                        const { path, element, authRequired } = route;
                        return authRequired && <Route key={i} path={path} element={element} />;
                    })}
                </Route>
            </Routes>
        </Router>
    );
}

export default RouterApp;
